import React from "react";
import Subtotal from "./Subtotal";
import "./Checkout.css";
import CheckoutProduct from "./CheckoutProduct";
import { useStateValue } from "./StateProvider";
import FlipMove from "react-flip-move";

function Checkout() {
  const [{ cart, user }, dispatcher] = useStateValue();

  return (
    <div className="checkout">
      <div className="checkout__left">
        <img
          className="checkout__banner"
          src="https://images-eu.ssl-images-amazon.com/images/G/31/img17/Wireless/CEEX/AlphaStore/1500x375_V1_latest_PC._V529602317_.jpg"
          alt="checkout_banner"
        />

        <div>
          <h2>Hello, {user ? user.email : "Guest"}</h2>
          <h2 className="checkout__title">Your Shopping Cart</h2>
          <FlipMove duration={500}>
            {cart.map((item) => {
              return <CheckoutProduct key={item.productId} data={item} />;
            })}
          </FlipMove>
        </div>
      </div>

      <div className="checkout__right">
        <Subtotal />
      </div>
    </div>
  );
}

export default Checkout;
